import React from 'react';

const FlexOne = () => <span style={{flex: 1}}/>

export default FlexOne;